import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "container-fluid mt-3" }

import { ref, onMounted, getCurrentInstance } from 'vue';
import store from "@/store";

import Navbar from "./components/Navbar.vue";
import LoadingModal from "./components/modals/LoadingModal.vue";

import { AppState } from "@/store/app/types";
import moment from "moment-timezone";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const appState: AppState = store.state.app;
const route = ref(getCurrentInstance()?.proxy!.$route);

moment.tz.setDefault(appState.timezone);

window.addEventListener("beforeunload", (event) => {
  if (
    store.getters["customers/hasUnsavedChanges"] ||
    store.getters["dictionary/hasUnsavedChanges"] ||
    store.getters["reports/hasUnsavedChanges"] ||
    store.getters["customerdictionary/hasUnsavedChanges"]
  ) {
    event.preventDefault();
    event.returnValue = "";
  }
  else if (
    (route.value?.name === 'newbooking' || route.value?.name === 'existingbooking') && 
    store.getters["diary/hasUnsavedChanges"]
  ) {
    event.preventDefault();
    event.returnValue = "";
  }
});

onMounted(() => {
  document.title = 'ACT Property CMS';
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingModal),
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})